import axios from "axios";
import { filterRecords } from "utils/common";
import { getSessionList } from "./program";
import { trackEvent } from "utils/analytics";
export const GET_SESSIONS_DATA = "get_sessions_data";
export const SET_CURRENT_SESSION = "set_current_session";
export const SET_SESSION_COMPLETION = "set_session_completion";
export const CLEAR_COMPLETION_MAP = "clear_completion_map";
export const getSessions = (tab = 0) => {
  return (dispatch) => {
    dispatch(loadingSessions(true));
    let url = "/api/coach/sessions?independent_session=true";
    if (tab === 1) url += "&my_templates=true";
    else if (tab === 2) url += "&is_template=true";
    axios
      .get(url)
      .then((res) => {
        dispatch({
          type: GET_SESSIONS_DATA,
          payload: res.data.data,
        });
        dispatch(loadingSessions(false));
      })
      .catch(() => {
        dispatch(loadingSessions(false));
      });
  };
};

export const PAGINATION_SESSIONS_DATA = "pagination_sessions_data";
export const changePagination = (response = 1) => {
  return (dispatch) => {
    dispatch({
      type: PAGINATION_SESSIONS_DATA,
      payload: response,
    });
  };
};

export const SEARCH_SESSIONS_DATA = "search_sessions_data";
export const searchSessions = (search = "", filters = []) => {
  return (dispatch, getState) => {
    let filteredItem = getState().sessions.searchedSessions || [];
    filteredItem = filterRecords(filteredItem, search, filters, "status");
    dispatch({
      type: SEARCH_SESSIONS_DATA,
      payload: filteredItem,
    });
  };
};

export const LOADING_SESSIONS_DATA = "loading_sessions_data";
export const loadingSessions = (response = false) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_SESSIONS_DATA,
      payload: response,
    });
  };
};

export const deleteSessionById = (sessionId = "", toggleDeleteModel) => {
  return (dispatch, getState) => {
    axios
      .delete(`/api/coach/sessions/${sessionId}`)
      .then(() => {
        trackEvent('Sessions', 'session_deleted');
        dispatch(getSessions());
        toggleDeleteModel();
      })
      .catch((err) => {
        toggleDeleteModel();
      });
  };
};

export const copySession = (_id = "") => {
  return (dispatch) => {
    return axios
      .get(`/api/coach/session/${_id}/copy`)
      .then((res) => {
        return res.data?.data?._id || null;
      })
      .catch(() => null);
  };
};
